export enum BELT_COLOR {
  WHITE = "white",
  YELLOW = "yellow",
  ORANGE = "orange",
  GREEN = "green",
  BLUE = "blue",
  PURPLE = "purple",
  BROWN = "brown",
  BLACK = "black",
  RED = "red",
  BRONZE = "bronze",
  SILVER = "silver",
  GOLD = "gold",
  GOD = "god",
}

export enum BELT_PROGRESSION_AUTHORIZED {
  FULL = 11,
  RESTRICTED = 7,
  STARTER = 2,
}

export const BELT = [
  BELT_COLOR.WHITE,
  BELT_COLOR.YELLOW,
  BELT_COLOR.ORANGE,
  BELT_COLOR.GREEN,
  BELT_COLOR.BLUE,
  BELT_COLOR.PURPLE,
  BELT_COLOR.BROWN,
  BELT_COLOR.BLACK,
  BELT_COLOR.RED,
  BELT_COLOR.BRONZE,
  BELT_COLOR.SILVER,
  BELT_COLOR.GOLD,
  BELT_COLOR.GOD,
]

export function getBeltColor(level: number): BELT_COLOR {
  if (level >= BELT.length) {
    return BELT[BELT.length - 1]
  }
  return BELT[level]
}

export function getColorFromBelt(belt: BELT_COLOR) {
  switch (belt) {
    case BELT_COLOR.WHITE:
      return "text-gray-300"
    case BELT_COLOR.YELLOW:
      return "text-amber-200"
    case BELT_COLOR.ORANGE:
      return "text-orange-500"
    case BELT_COLOR.GREEN:
      return "text-green-600"
    case BELT_COLOR.BLUE:
      return "text-blue-500"
    case BELT_COLOR.PURPLE:
      return "text-purple-700"
    case BELT_COLOR.BROWN:
      return "text-amber-800"
    case BELT_COLOR.BLACK:
      return "text-black"
    case BELT_COLOR.RED:
      return "text-red-600"
    case BELT_COLOR.BRONZE:
      return "text-amber-600"
    case BELT_COLOR.SILVER:
      return "text-zinc-200"
    case BELT_COLOR.GOLD:
      return "text-yellow-300"
    case BELT_COLOR.GOD:
      return "text-blue-300"
  }
}
